import React, { useMemo, useState } from 'react';
import { LanguageEnum } from '../../constants';
import { getCurrentLanguage } from '../../LanguageHelper';
import { Button } from '../../components/Button';
import './MaintenanceBannerScreen.css';

const MaintenanceBannerScreen = ({
  dutchContent,
  frenchContent,
  englishContent,
  children
}) => {
  const language = useMemo(() => getCurrentLanguage(), []);
  const [bannerClosed, setBannerClosed] = useState(false);

  const renderSwitch = lang => {
    switch (lang) {
      case LanguageEnum.EN:
        return englishContent || '';
      case LanguageEnum.FR:
        return frenchContent || '';
      case LanguageEnum.NL:
        return dutchContent || '';
      default:
        return englishContent || '';
    }
  };

  return (
    <div className="MaintenanceBannerScreen">
      {!bannerClosed && (
        <div className="banner">
          <span dangerouslySetInnerHTML={{ __html: renderSwitch(language) }} />
          <div className="banner__footer">
            <Button
              className="banner__button"
              style={{ minWidth: 60, padding: 0 }}
              keys={['MaintenanceBannerScreen', 'Close']}
              onClick={() => setBannerClosed(true)}
            />
          </div>
        </div>
      )}
      {children}
    </div>
  );
};

export default MaintenanceBannerScreen;
